<ng-container *ngIf="showHeader">
    <img class="banner-img center-block div-print" src="https://gestionatupyme-public.s3.amazonaws.com/banner.png"
        alt="" />
</ng-container>

<mat-card class="simple-card mx-auto">
    <mat-card-content>
        <div class="row">

            <div class="col-12 d-flex justify-content-between" *ngIf="showHeader">
                <h1>Certificado de estatuto actualizado</h1>
                <button mat-flat-button class="custom-button-primary no-print"
                    [printTitle]='"CertificadoEstatutoActualizado_"+(rut | rutFormat)+"_"+today' [useExistingCss]="true"
                    printSectionId="print-section" ngxPrint>
                    <mat-icon aria-hidden="false" aria-label="Icono de descarga" fontIcon="get_app"
                        class="icon-download"></mat-icon>
                    Descargar Resultado
                </button>
            </div>

            <div class="col-12 my-3" *ngIf="showHeader">
                <mat-chip-set aria-label="Rut principal">
                    <mat-chip class="chip-rut">
                        <strong>RUT:</strong> {{datosBasicosSolicitud.Rut | number:'1.0-0'}}-{{datosBasicosSolicitud.DV
                        | uppercase}}</mat-chip>
                </mat-chip-set>
            </div>

            <div class="col-12">
                <mat-card class="mt-5">
                    <mat-card-header>
                        <mat-card-title class="font-size-title-card">
                            <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                            <strong>Certificado de estatuto actualizado</strong>
                        </mat-card-title>
                    </mat-card-header>

                    <mat-card-content>
                        <div class="p-5">
                            <div class="border grid p-5">
                                <div class="font-weight-500">Razón social:</div>
                                <div>{{ content.RazonSocial }}</div>

                                <div class="font-weight-500">Rut empresa:</div>
                                <div>{{ content.RutSociedad | rutFormat }}</div>

                                <div class="font-weight-500">Domicilio:</div>
                                <div>{{ content.Domicilio }}</div>

                                <div class="font-weight-500">Objeto:</div>
                                <div>{{ content.Objeto }}</div>

                                <div class="font-weight-500">Capital:</div>
                                <div>${{ content.Capital | number: '1.0-0' }}</div>

                            </div>
                        </div>

                    </mat-card-content>
                </mat-card>

                <mat-card class="mt-5">
                    <mat-card-header>
                        <mat-card-title class="font-size-title-card">
                            <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                            <strong>Antecedentes</strong>
                        </mat-card-title>
                    </mat-card-header>

                    <mat-card-content>
                        <div class="p-5">
                            <div class="border grid p-5">
                                <div class="font-weight-500">Inscripción:</div>
                                <div>{{ content.CodigoVerificacion }}</div>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>



            </div>

            <div class="col-12 mt-5 mb-3">
                <mat-card>
                    <mat-card-header>
                        <mat-card-title class="font-size-title-card">
                            <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                            <strong>Información adicional</strong>
                        </mat-card-title>
                    </mat-card-header>

                    <mat-card-content>

                        <mat-tab-group class="no-print">

                            <mat-tab label="Comparecientes">
                                <div class="row p-5 m-0">
                                    <div class="col-12 border mx-auto px-0">
                                        <div class="table-responsive">
                                            <table mat-table [dataSource]="comparecientesDataSource"
                                                class="custom-print-table">
                                                <ng-container matColumnDef="rut">
                                                    <th mat-header-cell *matHeaderCellDef>Rut</th>
                                                    <td mat-cell *matCellDef="let element">{{ element.Rut | rutFormat }}
                                                    </td>
                                                </ng-container>

                                                <ng-container matColumnDef="nombre">
                                                    <th mat-header-cell *matHeaderCellDef>Nombre</th>
                                                    <td mat-cell *matCellDef="let element">{{ element.Nombre }}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="domicilio">
                                                    <th mat-header-cell *matHeaderCellDef>Domicilio</th>
                                                    <td mat-cell *matCellDef="let element">{{ element.Direccion }}</td>
                                                </ng-container>

                                                <tr mat-header-row *matHeaderRowDef="comparecientesDisplayedColumns">
                                                </tr>
                                                <tr mat-row
                                                    *matRowDef="let row; columns: comparecientesDisplayedColumns;"></tr>

                                                <tr class="mat-mdc-row" *matNoDataRow>
                                                    <td class="mat-mdc-cell text-center font-weight-500"
                                                        [attr.colspan]="comparecientesDisplayedColumns.length">
                                                        No hay datos disponibles
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </mat-tab>

                            <mat-tab label="Socios">
                                <div class="row p-5 m-0">
                                    <div class="col-12 border mx-auto px-0">
                                        <div class="table-responsive">
                                            <table mat-table [dataSource]="sociosDataSource" class="custom-print-table">
                                                <ng-container matColumnDef="nombre">
                                                    <th mat-header-cell *matHeaderCellDef>Nombre</th>
                                                    <td mat-cell *matCellDef="let element">{{ element.Nombre }}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="monto">
                                                    <th mat-header-cell *matHeaderCellDef>Monto</th>
                                                    <td mat-cell *matCellDef="let element">${{ element.Monto | number:
                                                        '1.0-0' }}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="porcentaje">
                                                    <th mat-header-cell *matHeaderCellDef>Porcentaje</th>
                                                    <td mat-cell *matCellDef="let element">{{ element.Porcentaje }}%
                                                    </td>
                                                </ng-container>

                                                <ng-container matColumnDef="tipoAporte">
                                                    <th mat-header-cell *matHeaderCellDef>Tipo de aporte</th>
                                                    <td mat-cell *matCellDef="let element">{{ element.TipoAporte }}</td>
                                                </ng-container>

                                                <tr mat-header-row *matHeaderRowDef="sociosDisplayedColumns"></tr>
                                                <tr mat-row *matRowDef="let row; columns: sociosDisplayedColumns;"></tr>

                                                <tr class="mat-mdc-row" *matNoDataRow>
                                                    <td class="mat-mdc-cell text-center font-weight-500"
                                                        [attr.colspan]="sociosDisplayedColumns.length">
                                                        No hay datos disponibles
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </mat-tab>

                            <mat-tab label="Facultades / Poderes">
                                <div class="row p-5 m-0">
                                    <div class="col-12 border mx-auto px-0">
                                        <div class="table-responsive">
                                            <table mat-table [dataSource]="facultadesDataSource"
                                                class="custom-print-table">
                                                <ng-container matColumnDef="poderes">
                                                    <th mat-header-cell *matHeaderCellDef>Poderes</th>
                                                    <td mat-cell *matCellDef="let element">{{ element.poder }}</td>
                                                </ng-container>

                                                <tr mat-header-row *matHeaderRowDef="facultadesDisplayedColumns"></tr>
                                                <tr mat-row *matRowDef="let row; columns: facultadesDisplayedColumns;">
                                                </tr>

                                                <tr class="mat-mdc-row" *matNoDataRow>
                                                    <td class="mat-mdc-cell text-center font-weight-500"
                                                        [attr.colspan]="facultadesDisplayedColumns.length">
                                                        No hay datos disponibles
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </mat-tab>

                            <mat-tab label="Artículos">
                                <div class="row p-5 m-0">
                                    <div class="col-12">
                                        <mat-accordion>

                                            <mat-expansion-panel *ngFor="let element of articulosDataSource" #panel>
                                                <mat-expansion-panel-header>
                                                    <mat-panel-title>
                                                        {{ element.tipo }}
                                                    </mat-panel-title>
                                                    <mat-panel-description class="d-block text-truncate">
                                                        {{ panel.expanded ? '' : element.glosa }}
                                                    </mat-panel-description>
                                                </mat-expansion-panel-header>
                                                <p>{{ element.glosa }}</p>
                                            </mat-expansion-panel>

                                        </mat-accordion>
                                    </div>
                                </div>
                            </mat-tab>

                            <mat-tab label="Historial actuaciones / Anotaciones">
                                <div class="row p-5 m-0">
                                    <div class="col-12 border mx-auto px-0">
                                        <div class="table-responsive">
                                            <table mat-table [dataSource]="historialActuacionesAnotacionesDataSource" class="custom-print-table">
                                                <ng-container matColumnDef="item">
                                                    <th mat-header-cell *matHeaderCellDef>Item</th>
                                                    <td mat-cell *matCellDef="let element">{{ element.Item }}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="fecha">
                                                    <th mat-header-cell *matHeaderCellDef>Fecha</th>
                                                    <td mat-cell *matCellDef="let element">{{ element.Fecha }}</td>
                                                </ng-container>

                                                <ng-container matColumnDef="codigoVerificacion">
                                                    <th mat-header-cell *matHeaderCellDef>Código de verificación</th>
                                                    <td mat-cell *matCellDef="let element">{{ element.CodigoVerificacion }}</td>
                                                </ng-container>

                                                <tr mat-header-row *matHeaderRowDef="historialActuacionesAnotacionesDisplayedColumns"></tr>
                                                <tr mat-row *matRowDef="let row; columns: historialActuacionesAnotacionesDisplayedColumns;">
                                                </tr>

                                                <tr class="mat-mdc-row" *matNoDataRow>
                                                    <td class="mat-mdc-cell text-center font-weight-500"
                                                        [attr.colspan]="historialActuacionesAnotacionesDisplayedColumns.length">
                                                        No hay datos disponibles
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </mat-tab>

                        </mat-tab-group>

                        <!-- Tablas para imprimir -->

                        <div class="div-print">

                            <div class="row p-5 m-0 no-break">
                                <h5 class="mb-3 font-weight-bold">Comparecientes</h5>
                                <div class="col-12 border mx-auto px-0">
                                    <div class="table-responsive">
                                        <table mat-table [dataSource]="comparecientesDataSource"
                                            class="custom-print-table">
                                            <ng-container matColumnDef="rut">
                                                <th mat-header-cell *matHeaderCellDef>Rut</th>
                                                <td mat-cell *matCellDef="let element">{{ element.Rut | rutFormat }}
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="nombre">
                                                <th mat-header-cell *matHeaderCellDef>Nombre</th>
                                                <td mat-cell *matCellDef="let element">{{ element.Nombre }}</td>
                                            </ng-container>

                                            <ng-container matColumnDef="domicilio">
                                                <th mat-header-cell *matHeaderCellDef>Domicilio</th>
                                                <td mat-cell *matCellDef="let element">{{ element.Direccion }}</td>
                                            </ng-container>

                                            <tr mat-header-row *matHeaderRowDef="comparecientesDisplayedColumns">
                                            </tr>
                                            <tr mat-row
                                                *matRowDef="let row; columns: comparecientesDisplayedColumns;"></tr>

                                            <tr class="mat-mdc-row" *matNoDataRow>
                                                <td class="mat-mdc-cell text-center font-weight-500"
                                                    [attr.colspan]="comparecientesDisplayedColumns.length">
                                                    No hay datos disponibles
                                                </td>
                                            </tr>
                                        </table>
                                    </div>

                                </div>
                            </div>

                            <div class="row p-5 m-0 no-break">
                                <h5 class="mb-3 font-weight-bold">Socios</h5>
                                <div class="col-12 border mx-auto px-0">
                                    <div class="table-responsive">
                                        <table mat-table [dataSource]="sociosDataSource" class="custom-print-table">
                                            <ng-container matColumnDef="nombre">
                                                <th mat-header-cell *matHeaderCellDef>Nombre</th>
                                                <td mat-cell *matCellDef="let element">{{ element.Nombre }}</td>
                                            </ng-container>

                                            <ng-container matColumnDef="monto">
                                                <th mat-header-cell *matHeaderCellDef>Monto</th>
                                                <td mat-cell *matCellDef="let element">${{ element.Monto | number:
                                                    '1.0-0' }}</td>
                                            </ng-container>

                                            <ng-container matColumnDef="porcentaje">
                                                <th mat-header-cell *matHeaderCellDef>Porcentaje</th>
                                                <td mat-cell *matCellDef="let element">{{ element.Porcentaje }}%
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="tipoAporte">
                                                <th mat-header-cell *matHeaderCellDef>Tipo de aporte</th>
                                                <td mat-cell *matCellDef="let element">{{ element.TipoAporte }}</td>
                                            </ng-container>

                                            <tr mat-header-row *matHeaderRowDef="sociosDisplayedColumns"></tr>
                                            <tr mat-row *matRowDef="let row; columns: sociosDisplayedColumns;"></tr>

                                            <tr class="mat-mdc-row" *matNoDataRow>
                                                <td class="mat-mdc-cell text-center font-weight-500"
                                                    [attr.colspan]="sociosDisplayedColumns.length">
                                                    No hay datos disponibles
                                                </td>
                                            </tr>
                                        </table>
                                    </div>

                                </div>
                            </div>

                            <div class="row p-5 m-0 no-break">
                                <h5 class="mb-3 font-weight-bold">Facultades / Poderes</h5>
                                <div class="col-12 border mx-auto px-0">
                                    <div class="table-responsive">
                                        <table mat-table [dataSource]="facultadesDataSource"
                                            class="custom-print-table">
                                            <ng-container matColumnDef="poderes">
                                                <th mat-header-cell *matHeaderCellDef>Poderes</th>
                                                <td mat-cell *matCellDef="let element">{{ element.poder }}</td>
                                            </ng-container>

                                            <tr mat-header-row *matHeaderRowDef="facultadesDisplayedColumns"></tr>
                                            <tr mat-row *matRowDef="let row; columns: facultadesDisplayedColumns;">
                                            </tr>

                                            <tr class="mat-mdc-row" *matNoDataRow>
                                                <td class="mat-mdc-cell text-center font-weight-500"
                                                    [attr.colspan]="facultadesDisplayedColumns.length">
                                                    No hay datos disponibles
                                                </td>
                                            </tr>
                                        </table>
                                    </div>

                                </div>
                            </div>

                            <div class="row p-5 m-0 no-break">
                                <h5 class="mb-3 font-weight-bold">Artículos</h5>
                                <div class="col-12 border mx-auto px-0">
                                    <div class="table-responsive">
                                        <table mat-table [dataSource]="articulosDataSource"
                                            class="custom-print-table">
                                            <ng-container matColumnDef="tipo">
                                                <th mat-header-cell *matHeaderCellDef>Tipo</th>
                                                <td mat-cell *matCellDef="let element" class="align-top">{{ element.tipo }}</td>
                                            </ng-container>

                                            <ng-container matColumnDef="glosa">
                                                <th mat-header-cell *matHeaderCellDef>Glosa</th>
                                                <td mat-cell *matCellDef="let element">{{ element.glosa }}</td>
                                            </ng-container>

                                            <tr mat-header-row *matHeaderRowDef="articulosDisplayedColumns"></tr>
                                            <tr mat-row *matRowDef="let row; columns: articulosDisplayedColumns;">
                                            </tr>

                                            <tr class="mat-mdc-row" *matNoDataRow>
                                                <td class="mat-mdc-cell text-center font-weight-500"
                                                    [attr.colspan]="articulosDisplayedColumns.length">
                                                    No hay datos disponibles
                                                </td>
                                            </tr>
                                        </table>
                                    </div>

                                </div>
                            </div>

                            <div class="row p-5 m-0 no-break">
                                <h5 class="mb-3 font-weight-bold">Historial actuaciones / Anotaciones</h5>
                                <div class="col-12 border mx-auto px-0">
                                    <div class="table-responsive">
                                        <table mat-table [dataSource]="historialActuacionesAnotacionesDataSource" class="custom-print-table">
                                            <ng-container matColumnDef="item">
                                                <th mat-header-cell *matHeaderCellDef>Item</th>
                                                <td mat-cell *matCellDef="let element">{{ element.Item }}</td>
                                            </ng-container>

                                            <ng-container matColumnDef="fecha">
                                                <th mat-header-cell *matHeaderCellDef>Fecha</th>
                                                <td mat-cell *matCellDef="let element">{{ element.Fecha }}</td>
                                            </ng-container>

                                            <ng-container matColumnDef="codigoVerificacion">
                                                <th mat-header-cell *matHeaderCellDef>Código de verificación</th>
                                                <td mat-cell *matCellDef="let element">{{ element.CodigoVerificacion }}</td>
                                            </ng-container>

                                            <tr mat-header-row *matHeaderRowDef="historialActuacionesAnotacionesDisplayedColumns"></tr>
                                            <tr mat-row *matRowDef="let row; columns: historialActuacionesAnotacionesDisplayedColumns;">
                                            </tr>

                                            <tr class="mat-mdc-row" *matNoDataRow>
                                                <td class="mat-mdc-cell text-center font-weight-500"
                                                    [attr.colspan]="historialActuacionesAnotacionesDisplayedColumns.length">
                                                    No hay datos disponibles
                                                </td>
                                            </tr>
                                        </table>
                                    </div>

                                </div>
                            </div>

                        </div>

                    </mat-card-content>
                </mat-card>
            </div>

        </div>
    </mat-card-content>
</mat-card>